import React, { useState, useEffect } from "react";
import axios from "axios";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCommentDots } from "@fortawesome/free-solid-svg-icons";
import { BrowserRouter as Router, withRouter } from "react-router-dom";
import { Modal, Button } from "react-bootstrap";
import apiUrl from "../apiUrlConstant";
import Select from "react-select";
import {
  Chart as ChartJS,
  LineController,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Line, Bar } from "react-chartjs-2";
import { Chart } from "react-google-charts";
ChartJS.register(
  LineController,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  Title,
  Tooltip,
  Legend
);
const labels = [];

const formHeaders = {
  "Content-Type": "application/json",
  Authorization: "Bearer " + localStorage.getItem("TOKEN"),
};

export const chartOneOptions = {
  chart: {
    title: "Sales View Report",
  },
  legend: { position: "right" },
};

export const chartRentOptions = {
  chart: {
    title: "Lease Rent Trend",
  },
  legend: { position: "right" },
};

class LeaseGraphPopup extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      IsModalOpened: this.props.IsModalOpened,
      onCloseModal: this.props.onCloseModal,
      leaseId: this.props.leaseId,
      fySelected: [],
      leaseData: {},
      fianancialYears: [],
      popupHeading: "",
      chartOneData: [
        // [
        //   "Months",
        //   "2022-23",
        // ],
        // ["Mon", 37.8, 80.8, 41.8],
        // [2, 30.9, 69.5, 32.4],
      ],

      chartRentData: [],
    };
  }
  componentDidMount() {
    fetch(
      `${apiUrl.apiUrl.url}/lease-view/get-lease-financial-years?leaseId=${this.state.leaseId}`,
      {
        method: "GET",
        headers: formHeaders, // Correct way to pass headers
      }
    )
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        console.log(data, "data");
        this.setState({
          leaseData: data.data,
          fianancialYears: data.fianancialYears,
        });
      })
      .catch((error) => {
        console.log(error);
      });

    this.loadLeaseRentData();
    this.fetchSalesData();
  }
  amendNumber(str) {
    return str.split("-").pop();
  }

  loadLeaseSalesData(newValue) {
    var ths = this;
    this.state.fySelected = [];
    this.state.fyArr = [];
    console.log(newValue, "newValue");
    for (let i = 0; i < newValue.length; i++) {
      this.state.fyArr.push(newValue[i].value);
      this.state.fySelected.push({
        value: newValue[i].value,
        label: newValue[i].label,
      });
    }
    this.setState({});
    this.fetchSalesData();
  }

  fetchSalesData() {
    var ths = this;
    axios({
      method: "post",
      url: `${apiUrl.apiUrl.url}/lease-view/get-lease-sales-data-for-graph?leaseId=${this.state.leaseId}`,
      data: { leaseId: this.state.leaseId, year: this.state.fyArr },
    }).then(function (response) {
      if(typeof response.data.data != "undefined") {
        ths.setState({ chartOneData: response.data.data });
      }
    });
  }

  loadLeaseRentData(str) {
    var ths = this;
    axios({
      method: "post",
      url: `${apiUrl.apiUrl.url}/lease-view/get-lease-rent-data-for-graph?leaseId=${this.state.leaseId}`,
      data: { leaseId: this.state.leaseId, year: str },
    }).then(function (response) {
      console.log(response, "response rent");

      ths.setState({ chartRentData: response.data.data });
    });
  }

  setPopupHeading() {
    // if (
    //   this.state.leaseData.type == "" ||
    //   this.state.leaseData.type == "original"
    // ) {
    //   return "Create Lease";
    // } else if (this.state.leaseData.type == "amend") {
    //   return "Amend Lease";
    // } else if (this.state.leaseData.type == "extend") {
    //   return "Extend Lease";
    // } else if (this.state.leaseData.type == "renew") {
    //   return "Renew Lease";
    // } else if (this.state.leaseData.type == "terminate") {
    //   return "Terminate Lease";
    // } else {
    //   return "Create Lease";
    // }
  }
  render() {
    return (
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <Modal
              show={this.props.IsModalOpened}
              onHide={this.props.onCloseModal}
              size="xl"
              className="documentModal"
            >
              <Modal.Header closeButton>
                <Modal.Title>
                  <div className="container modalBreadCrumbs">
                    <div className="row">
                      <div className="col-lg-12">
                        <ul>
                          <li>Lease Details: {this.setPopupHeading()}</li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <div className="unitFormContainer amend">
                  <div className="container">
                    <div className="row">
                      <div className="col-lg-12">
                        <div className="inputContainer">
                          <select
                            className="mb-2"
                            onChange={(e) => {
                              this.loadLeaseRentData(e.target.value);
                            }}
                          >
                            <option value="">Select FY</option>
                            {this.state.fianancialYears.map((x) => (
                              <option key={x.value} value={x.value}>
                                {x.value}
                              </option>
                            ))}
                          </select>
                          <div
                            style={{
                              backgroundColor: "#fff",
                              textAlign: "center",
                              fontWeight: "600",
                              padding: "5px",
                            }}
                          >
                            {this.state.chartRentData.length > 0 ? (
                              <Chart
                                chartType="Line"
                                data={this.state.chartRentData}
                                options={chartRentOptions}
                                width={"100%"}
                                height={"400px"}
                                legendToggle
                              />
                            ) : (
                              "No Data Available For this Financial Year"
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-12">
                        <div className="inputContainer">
                          <Select
                            className="basic-single mb-2"
                            name="brandId"
                            onInputChange={this.handleChange}
                            // onChange={}
                            isMulti
                            onChange={(e) => {
                              console.log(e, "e ka value");
                              //this.valueChange(e, "change_brand");
                              this.loadLeaseSalesData(e);
                            }}
                            value={this.state.fySelected}
                            options={this.state.fianancialYears.map((item) => ({
                              label: item.value,
                              value: item.value,
                            }))}
                          />
                          <div
                            style={{
                              backgroundColor: "#fff",
                              textAlign: "center",
                              fontWeight: "600",
                              padding: "5px",
                            }}
                          >
                            {this.state.chartOneData.length > 0 ? (
                              <Chart
                                chartType="Line"
                                data={this.state.chartOneData}
                                options={chartOneOptions}
                                width={"100%"}
                                height={"400px"}
                                legendToggle
                              />
                            ) : (
                              "No Data Available For this Financial Year"
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Modal.Body>
            </Modal>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(LeaseGraphPopup);
